<div class="create-intel-container  pl-7 pb-5 radius-s">
    <rule-tabs (selectedIndexChange)="changeTab($event)" [selectedIndex]="rulevarservice.intelSelectedIndex" 
        [tabclickChange]=false [formGroup]="rulevarservice.intelForm" >
        <tab [label]="'1. Context'">
            <div class="context pt-9 white-bg px-3" formGroupName="context" >
                <div class="col-1">
                    <div class="list-name input-label-1">
                        <div class="context-content">
                            <div class="labelName-content">
                                <p class="primary-text content-l bold-text">List Name</p>
                                <p class="alert-text content-l bold-text">*</p>
                                <!-- <p class="primary-text content-l bold-text">: </p> -->
                            </div>
                            <!-- <p class="primary-text content-l bold-text">List Name* : </p> -->
                            <input class="primary-text input-m bold-text input-border " [ngClass]="rulevarservice.intelEditMode ? 'disabled-input':'white-bg'" placeholder="List name" type="text" formControlName="listName">
                        </div>
                        <div class="context-error">
                            <!-- <ng-container *ngIf="rulevarservice.contextShowError.listName == true"> -->
                            <ng-container *ngIf="listName.touched">
                                <!-- <p class="alert-text content-s">{{rulevarservice.contextErrors.listName}}</p> -->
                                    <p class="alert-text content-s">{{nameError|oneError:listName.errors}}</p>
                            </ng-container>
                        </div>
                    </div>
                    <div class="platform input-label-1">
                        <p class="primary-text content-l bold-text">Platform </p>
                        <app-overlay-select  [data]="platformList" [ngClass]="rulevarservice.intelEditMode ? 'disabled-input':''" formControlName="platform"></app-overlay-select>
                    </div>
                    <div class="unique permission-denied input-label-1">
                        <p class="primary-text content-l bold-text">Is Unique </p>
                        <input class="primary-text input-m bold-text white-bg" [ngClass]="rulevarservice.intelEditMode ? 'disabled-input':''"  placeholder="Enter Max Rows " type="checkbox" formControlName="unique">
                    </div>
                    
                </div>
                <div class="col-2">
                    <div class="max-entry input-label">
                        <p class="primary-text content-l bold-text">Maximum Entry </p>
                        <app-overlay-select [data]="rulevarservice.maxEntry" formControlName="maxEntry"></app-overlay-select>

                    </div>
                    <div class="period">
                        <div class="learning">
                            <div class="context-content input-label">
                                <div class="LP-label">
                                    <p class="primary-text content-l bold-text">Learning period (LP)</p>
                                    <p class="alert-text content-l bold-text">*</p>
                                    <!-- <p class="primary-text content-l bold-text">:</p> -->
                                </div>
                                <!-- <p class="primary-text content-l bold-text">Learning period (LP)* :</p> -->
                            </div>
                            <div class="learning-inputs">
                                <div class="learning-input-1">
                                    <input class="primary-text input-m bold-text input-border " [ngClass]="rulevarservice.intelEditMode ? 'disabled-input':'white-bg'" min="1"   placeholder="LP" type="number" formControlName="learningPeriodValue">
                                    <div class="context-error">
                                        <ng-container *ngIf="rulevarservice.contextShowError.learning == true">
                                            <ng-container *ngIf="learningPeriodValue.value === 0">
                                                <p class="alert-text content-s">Learning Period can't be 0</p>
                                            </ng-container>
                                            <ng-container *ngIf="learningPeriodValue.value != 0">
                                                <p class="alert-text content-s">Learning Period can't be empty</p>
                                            </ng-container>
                                            <!-- <p class="alert-text content-s">{{rulevarservice.contextErrors.learning}}</p> -->
                                        </ng-container>
                                        <ng-container *ngIf="rulevarservice.learningTtlErr.learning == true">
                                            <p class="alert-text content-s">{{rulevarservice.learningTtlerrstr.learning}}</p>
                                        </ng-container>
                                    </div>
                                </div>
                                <div class="learning-input-2">
                                    <div class="time-unit">
                                        <app-overlay-select sort=false [data]="rulevarservice.timeUnit" [ngClass]="rulevarservice.intelEditMode ? 'disabled-input':''"  formControlName="learningUnit"></app-overlay-select>
                                    </div>
                                </div>
                            </div>
                           
                        </div>
                        
                    </div>
                    <div class="time">
                        <div class="ttl">
                            <div class="context-content input-label">
                                <div class="TTL-label">
                                    <p class="primary-text content-l bold-text">TTL (Time to live)</p>
                                    <p class="alert-text content-l bold-text">*</p>
                                    <!-- <p class="primary-text content-l bold-text">: </p> -->
                                </div>
                                <!-- <p class="primary-text content-l bold-text">TTL (Time to live)* : </p> -->
                            </div>
                            <div class="ttl-inputs">
                                <div class="ttl-input-1">
                                    <input class="primary-text input-m bold-text input-border white-bg"  placeholder="TTL" min="1" type="number" formControlName="ttlValue">
                                    <div class="context-error">
                                        <ng-container *ngIf="rulevarservice.contextShowError.TTL == true">
                                            <ng-container *ngIf="ttlValue.value === 0">
                                                <p class="alert-text content-s">Time to Live can't be 0</p>
                                            </ng-container>
                                            <ng-container *ngIf="ttlValue.value != 0">
                                                <p class="alert-text content-s">Time to Live can't be empty</p>
                                            </ng-container>
                                            <!-- <p class="alert-text content-s">{{rulevarservice.contextErrors.TTL}}</p> -->
                                        </ng-container>
                                        <ng-container *ngIf="rulevarservice.learningTtlErr.ttl == true">
                                            <p class="alert-text content-s">{{rulevarservice.learningTtlerrstr.ttl}}</p>
                                        </ng-container>
                                    </div>
                                </div>
                                <div class="ttl-input-2">
                                    <div class="time-unit">
                                        <app-overlay-select sort=false [data]="rulevarservice.timeUnit"  formControlName="timeUnit"></app-overlay-select>
                                    </div>
                                </div>
                            </div>
                          
                        </div>
                       
                    </div>
                </div>
            </div>
            <ng-template #Popup let-dialogRef="dialogRef">
                <!-- <h5 class="primary-text" mat-dialog-title>Do you want to delete rows above {{maxEntry.value}} ?</h5> -->
              
                <mat-dialog-content class="pl-5">
                    <p class="content-l primary-text">Do you want to delete rows above {{maxEntry.value}} ?</p>
                </mat-dialog-content>
              
                <mat-dialog-actions align="end" class="pr-5">
                    <button mat-button class="submit" (click)="popupYes()">YES</button>
                  <button mat-button class="cancel" (click)="popupNo()">NO</button>
                </mat-dialog-actions>
              </ng-template>
        </tab>
        <tab [label]="'2. Create List'">
            <div class="create-wrapper white-bg p-3 pb-4 " [formGroup]="rulevarservice.intelForm" (click)="emptyProp()">
                <div class="create-table mt-5" formGroupName="createTable">
                    <div class="table-content mt-4" [ngClass]="rulevarservice.intelEditMode ? '':''">
                        <div formArrayName="table" class="table">
                            <div class="thead">
                                <div class="tr white-bg border-light-right border-light-left border-light-top">
                                    <ng-container *ngFor="let head of rulevarservice.intelHead ; index as i">
                                        <div class="head-wrapper primary-bg" [ngClass]="[i === rulevarservice.intelHead.length-1 ? '': '',i === 0 ? '':'']">
                                            <p class="content-m bold-text primary-text pl-1">{{head}}</p>
                                        </div>
                                    </ng-container>
                                    <!-- <p class="content-m bold-text">Data Type</p>
                                    <th class="content-m bold-text">Description</th> -->
                                    <!-- <ng-container *ngIf="propertyHeader()"> -->
                                        <!-- <th class="content-m bold-text">Properties</th> -->
                                    <!-- </ng-container> -->
                                </div>
                            </div>
                        
                            <div class="tbody">
                                <ng-container *ngFor="let control of table.controls; index as i">
                                    <div class="primary-bg tr  border-light" [formGroupName]="i" (click)="openProperties(i)" [ngClass]="i === openIndex ? ' white-bg':''">
                                        <div class="td">
                                            <input class="primary-text input-m bold-text  primary-bg p-0" [formControl]="control.get('fieldName')"  type="text" [ngClass]="[i === openIndex ? 'white-bg':'',disableInput ? 'disabled-input':'']">
                                        </div>
                                        <div class="td primary-bg border-light-right border-light-left" type="text" [ngClass]="i === openIndex && !disableInput ? 'white-bg':''">
                                            <!-- <input class="primary-text input-m bold-text  primary-bg" [formControl]="control.get('dataType')"  type="text" > -->
                                            <app-overlay-select class=" primary-bg  " type="text" [ngClass]="[i === openIndex ? 'white-bg':'',disableInput ? 'disabled-input ':'']" fontsize =  "shadow-none p-0" overlaycontainer="border-none" [data]="rulevarservice.dataType" [formControl]="control.get('dataType')" ></app-overlay-select>
                                        </div>
                                        <div class="td">
                                            <input class="primary-text input-m bold-text  primary-bg p-0" type="text" [maxlength]="rulevarservice.description_limit" [ngClass]="[i === openIndex ? 'white-bg':'',disableInput ? 'disabled-input':'']" [formControl]="control.get('description')" (keydown.enter)="addClick(i,'keydown')"  type="text" >
                                        </div>
                                        <!-- <ng-container *ngIf="control.get('enrichable').value || control.get('alias').value"> -->
                                            <div class="td border-light-right">
                                                <div class=" readOnly p-3 primary-text primary-bg  border-light-left " type="text" [ngClass]="i === openIndex ? 'white-bg':''" >
                                                    <ng-container *ngFor="let name of rulevarservice.propList">
                                                        <!-- <ng-container *ngIf="control.get([name]).value"> -->
                                                            <ng-container *ngIf="name != 'alias'">
                                                            <div class="readOnly-values">
                                                            <p class="content-m primary-text "> {{rulevarservice.propListDisp[name]}}:</p>
                                                            <p class="content-m primary-text bolder-text"> {{control.get([name]).value}}</p>
                                                            </div>
                                                            </ng-container>
                                                            <ng-container *ngIf="name === 'alias'">
                                                                <div class="readOnly-values">
                                                                <p class="content-m primary-text "> {{rulevarservice.propListDisp[name]}}: </p>
                                                                <ng-container *ngIf="control.get([name]).value">
                                                                    <p class="content-m primary-text bolder-text">  ${{listName.value}}.{{control.get([name]).value}}</p>
                                                                </ng-container>
                                                                </div>
                                                            </ng-container>
                                                        </ng-container>
                                                    <!-- </ng-container> -->
                                                </div>
                                            </div>
                                        <!-- </ng-container> -->
                                        <div class="td add pl-5 enable-action white-shad border-light-right" type="text" [ngClass]="i === openIndex ? 'white-bg':'primary-bg'" >
                                            <!-- <p class="bold-text selectable-text" [tooltip]="Add" (click)="addClick(i)">+</p> -->
                                            <!-- <p class="bold-text selectable-text" [tooltip]="Remove" (click)="removeClick(i)">-</p> -->
                                           <ng-container *ngIf="rulevarservice.intelEditMode">
                                            <img class=" tooltip-enable icon-s" [tooltip]="'Edit'" src="../../../assets/rule/edit-row.svg" (click)="editClick(i)">
                                           </ng-container>
                                            <img class=" tooltip-enable icon-s" tooltip="Delete" [ngClass]="disableInput ? '':''" src="../../../assets/rule/delete.svg" (click)="removeClick(i)">
                                            <ng-container *ngIf="i === table.controls.length-1 && i != rulevarservice.intelColumnLimit-1">
                                                <img class="pl-3 tooltip-enable icon-s" tooltip="Add" [ngClass]="disableInput ? '':''" src="../../../assets/rule/plus.svg" (click)="addClick(i)">
                                            </ng-container>
                                        </div>
                                        <div class="alias-error white-bg white-shadow ">
                                            <!-- <ng-container *ngIf="!control.get('alias').valid"> -->
                                                <!-- <p class="content-s alert-text">*Alias Name is mandatory</p> -->
                                            <ng-container *ngIf="!control.get('fieldName').valid">
                                                <p class="content-s alert-text pl-3">{{fieldNameError|oneError:control.get('fieldName').errors}}</p>
                                            </ng-container>
                                            <ng-container *ngIf="control.get('fieldName').valid">
                                                <p class="pl-3 content-s alert-text">{{aliasError|oneError:control.get('alias').errors}}</p>
                                            </ng-container>

                                                
                                            <!-- </ng-container> -->
                                        </div>
                                        <!-- <div class="properties primary-bg bold-text selectable-text pl-5 enable-action" (click)="openProperties(i)"> > </div> -->
                                        <!-- <ng-container *ngIf="openIndex === i ; then properties"></ng-container> -->
                                    </div>
                                </ng-container>
                                <ng-template #editPopup let-dialogRef="dialogRef">
                                    <mat-dialog-content class="pl-5">
                                        <p class="content-l primary-text">This List has been referenced somewhere and cannot be edited.</p>
                                    </mat-dialog-content>
                                    <mat-dialog-actions align="end" class="pr-5">
                                        <button mat-button class="cancel" (click)="editPopupYes()">CLOSE</button>
                                    </mat-dialog-actions>
                                </ng-template>
                                <ng-template #editWarnPopup let-dialogRef="dialogRef">
                                    <mat-dialog-content class="m-0 pl-5 p-0">
                                        <p class="content-l primary-text">Editing will delete all the values in the list.Do you want to continue?</p>
                                    </mat-dialog-content>
                                    <mat-dialog-actions align="end" class="pr-5">
                                        <button mat-button class="submit" (click)="editWarnPopupYes()">YES</button>
                                        <button mat-button class="cancel" (click)="editWarnPopupNo()">NO</button>
                                    </mat-dialog-actions>
                                </ng-template>


                            </div>
                            
                        </div>
                        <!-- <ng-template #properties> -->
                            <ng-container *ngFor="let control of table.controls; index as i">
                                <ng-container *ngIf="openIndex === i">
                                    <div class="property-wrapper mt-1" formArrayName="table" >
                                        <div class="property-container" [formGroupName]="openIndex" (click)="propertyClicked()">
                                            
                                                <h4>{{dispstr}}</h4>
                                            
                                            <div class="enrich">
                                                <p class="content-m primary-text">Is Enrichable : </p>
                                                <input type="checkbox" class="border-none shadow-none enable-action" [ngClass]="disableInput ? 'disabled-input':''"  [formControl]="control.get('enrichable')">
                                            </div>
                                            <div class="alias">
                                                <p class="content-m primary-text">Alias :  ${{listName.value}}. </p>
                                                <input type="text" class="input-border alias-input" [ngClass]="disableInput ? 'disabled-input':''"  [formControl]="control.get('alias')">
                                            </div>
                                            <div class="allow-null">
                                                <p class="content-m primary-text">Is Allow Null : </p>
                                                <input type="checkbox" class="border-none shadow-none enable-action" [ngClass]="disableInput ? 'disabled-input':''"  [formControl]="control.get('isNull')">
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-container>
                        <!-- </ng-template> -->
                    </div>
                    <!-- <div class="createError" [ngClass]="rulevarservice.intelEditMode ? 'permission-denied':''">
                        <ng-container *ngIf="rulevarservice.createShowError">
                            <p class="alert-text content-s">{{createErrorString}}</p>
                        </ng-container>
                    </div> -->
                    <div class="populate-wrapper hide">
                        <div class="populate-values">
                            <h4 class="bold-text primary-text">Populate Values</h4>
                            
                            <div class="modes">
                                <ng-container *ngFor="let name of rulevarservice.entryModes">
                                    <div class="options">
                                        <input type="radio" formControlName="entryMode" [value]="name">
                                        <p class="primary-text content-m">{{name}}</p>
                                    </div>
                                </ng-container>
                            
                            </div>
                        
                        </div>
                        <div class="edit-mode" [ngClass]="rulevarservice.intelEditMode ? '':'permission-denied'">
                            <h4 class="bold-text primary-text"> Edit </h4>
                            <app-toggle-button formControlName="remove" [leftLabel]="rulevarservice.titles.insert" [rightLabel]="rulevarservice.titles.delete"></app-toggle-button>
                        </div>
                    </div>
                </div>
                
            </div>
        </tab>
        <!-- <tab [label]="'3. Add Intel'" [formGroup]="rulevarservice.intelForm">
            <ng-container *ngIf="entryMode.value === 'import'">
                <div class="import-wrapper pt-5 white-bg px-3" formGroupName="createTable">
                    <div class="file-wrapper">
                        <input class="input-border choose-file" (change)="onFileChange($event)"  type="file" accept=".xlsx, .xls, .csv" />
                    </div>
                
                    <div class="mapping-area" formArrayName="table">
                        <ng-container *ngIf="rawData.length">
                            <div class="sample-data">
                                
                                    <p class="primary-text content-m bold-text pr-2">Showing 20 of {{rawData.length}} Rows</p>
                                <div class="table">
                                    <table>
                                        <thead>
                                            <tr>
                                                <ng-container *ngIf="rawData.length">
                                                    <ng-container *ngFor="let head of rawData[0] | keyvalue: originalOrder">
                                                        <th>{{head.key}}</th>
                                                    </ng-container>
                                                </ng-container>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let head of rawData | slice:0:20">
                                                <ng-container *ngFor="let data of head | keyvalue: originalOrder">
                                                    <td [tooltip]="data.value">{{data.value}}</td>
                                                </ng-container>
                                                
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="rawData.length">
                            <div class="mapping-table">
                                <div class="map-wrapper">
                                    <h4 class="bold-text primary-text">Mapping Fields</h4>
                                    <div class="mapping-Titles mt-2">
                                        <p class="primary-text content-l bold-text ">Intel List Fields</p>
                                        <p class="primary-text content-l bold-text">Imported Fields</p>
                                    </div>
                                    <div class="columns">
                                        <ng-container *ngIf="rawData.length">
                                            <ng-container *ngFor="let field of table.controls ; index as i">

                                                <ng-container *ngIf="!field.get('enrichable').value">
                                                    <div class="mapping-rows" [formGroupName]="i">
                                                        <ng-container *ngIf="field.get('enrichable').value != true">
                                                            <p class="primary-text content-m createdFields">{{field.get('fieldName').value}}</p>
                                                            <p class="primary-text bold-text content-m equals">=</p>
                                                            <div class="inputNerror">
                                                                <app-overlay-select [data]="rulevarservice.importedFields" [formControl]="field.get('mappedField')"></app-overlay-select>
                                                                <div class="dataTypeError">
                                                                    <ng-container *ngFor="let data of rulevarservice.dataTypeError">
                                                                        <ng-container *ngIf="data === field.get('fieldName').value">
                                                                            <p class="alert-text content-s">{{rulevarservice.dataTypeErrorString}}</p>
                                                                        </ng-container>
                                                                    </ng-container>
                                                                </div>
                                                            </div>
                                                        </ng-container>
                                                    </div>
                                                </ng-container>
                                            </ng-container>
                                        </ng-container>
                                    </div>
                                   
                                </div>
                                <div class="import-error">
                                    <ng-container *ngIf="rulevarservice.importIntelError === true">
                                        <p class="alert-text content-s">{{importErrorString}}</p>
                                    </ng-container>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="entryMode.value === 'manual'">
                <div class="manual-wrapper white-bg p-3" [formGroup]="rulevarservice.manualIntel">
                    <div class="manual-table" formArrayName="manualTable">
                        <table>
                            <thead>
                                <tr>
                                    <ng-container *ngFor="let head of table.controls">
                                        <ng-container *ngIf="!head.get('enrichable').value">
                                            <td>{{head.get('fieldName').value}}</td>
                                        </ng-container>
                                    </ng-container>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let head of manualTable.controls ; index as i">
                                    <tr [formGroupName]="i">
                                        <ng-container *ngFor="let form of table.controls; index as j">
                                            <ng-container *ngIf="form.get('enrichable').value != true">
                                                <td>
                                                    <ng-container *ngIf="form.get('fieldName')?.value && form.get('dataType')?.value">
                                                        <ng-container *ngIf="form.get('dataType')?.value === 'text'">
                                                            <input type="text" [formControlName]="form.get('fieldName')?.value">
                                                        </ng-container>
                                                        <ng-container *ngIf="form.get('dataType')?.value === 'number'">
                                                            <input type="number" [formControlName]="form.get('fieldName')?.value">
                                                        </ng-container>
                                                        <ng-container *ngIf="form.get('dataType')?.value === 'inet'">
                                                            <input
                                                            type="text"
                                                            minlength="7"
                                                            maxlength="15"
                                                            size="15"
                                                            pattern="^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$"
                                                            [formControlName]="form.get('fieldName')?.value"
                                                            />
                                                        </ng-container>
                                                        

                                                    </ng-container>
                                                </td>
                                            </ng-container>
                                        </ng-container>
                                        <img src="../../../assets/rule/delete.svg" (click)="removeManualClick(i)" class="enable-action pl-2">
                                        <ng-container *ngIf="i === manualTable.controls.length-1">
                                            <img src="../../../assets/rule/plus.svg" (click)="addManualClick(i)" class="enable-action pl-2">
                                        </ng-container>
                                    </tr>
                                </ng-container>
                                
                            </tbody>
                        </table>
                        <div class="manual-error">
                            <ng-container *ngIf="rulevarservice.manualIntelError === true">
                                <p class="alert-text content-s">{{rulevarservice.manualErrorString}}</p>
                            </ng-container>
                        </div>
                        
                    </div>
                </div>
            </ng-container>
        </tab> -->
       
    </rule-tabs>
    <div class="buttons">
        <button class="submit" (click)="nextClick()">{{next}}</button>
        <button class="cancel" (click)="previousClick()">{{back}}</button>
    </div>
</div>
